import React from "react";

// STYLES
import {
  CardContainer,
  Description,
  FirstSection,
  IlustrationWrapper,
  LegislationWindowContainer,
  SectionTitle,
  StatisticSection,
  TextContentWrapper,
} from "./DSUNumbersStyled";

// LIBRARIES
import { useTranslation } from "react-i18next";

//ASETS
import { ReactComponent as QuarterCircle } from "assets/svg/QuarterCircle.svg";
import DSUNumbersIlustration from "assets/svg/DSUNumbersIlustration.svg";

// MISC
import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { COLORS } from "constants/variables";
import { StatisticCardData } from "constants/mocks/StatisticCard";

// REDUX
import StatisticCard from "components/Atoms/StatisticCard/StatisticCard";

// HOOKS

// COMPONENTS
import CustomText from "components/Atoms/CustomText/CustomText";

// CONFIGURATION

const DSUNumbers = () => {
  // PROPERTIES

  // API REQUESTS

  // LIBRARY CONSTANTS
  const { t } = useTranslation();

  // STATE CONSTANTS

  // LIFE CYCLE

  // EVENT HANDLERS

  return (
    <LegislationWindowContainer>
      <FirstSection>
        <QuarterCircle />
        <TextContentWrapper>
          <CustomText
            text={t("view.dsuNumbers.firstSection.title")}
            type={TextType.H2}
            color={COLORS.Yellow}
          />
          <CustomText
            text={t("view.dsuNumbers.firstSection.subtitle")}
            type={TextType.H3}
            color={COLORS.Background}
          />
          <Description>
            <CustomText
              text={t("view.dsuNumbers.firstSection.text")}
              type={TextType.P1}
              color={COLORS.Background}
            />
          </Description>
        </TextContentWrapper>
        <IlustrationWrapper src={DSUNumbersIlustration} />
      </FirstSection>
      <StatisticSection>
        <SectionTitle>
          <CustomText
            text={t("view.dsuNumbers.statisticSection.firstHalfTitle")}
            type={TextType.H2}
            color={COLORS.RaisinBlack}
          />
          <CustomText
            text={t("view.dsuNumbers.statisticSection.secondHalfTitle")}
            type={TextType.H2}
            color={COLORS.VividAuburn}
          />
        </SectionTitle>
        <CardContainer>
          {StatisticCardData.map((item, index) => (
            <StatisticCard
              key={index}
              antet={item.antet}
              title={item.title}
              href={item.href}
            />
          ))}
        </CardContainer>
      </StatisticSection>
    </LegislationWindowContainer>
  );
};

export default DSUNumbers;
